/**
 * Fixes SortSite issue (An element with aria-hidden=true contains focusable content.)
 * Solution based on https://web.dev/aria-hidden-focus/
 * @param {Array.<node>} panels - Array of panels that contain aria-hidden=true
 * @returns {Void} Func returns no value, it modifies DOM
 */
export const updateOffscreenPanelVisibility = (panels) => {
  panels.forEach((panel) => {
    const focusableElements = panel.querySelectorAll('button, a, input, select, textarea');

    if (panel.ariaHidden === 'true') {
      focusableElements.forEach((el) => {
        el.tabIndex = -1;
      });
    } else {
      focusableElements.forEach((el) => {
        el.tabIndex = 0;
      });
    }
  });
};
